export default __webpack_public_path__ + "static/dedicated-dev-team copy-8917709881633e7d1a233320dabd2f36.svg";